module.exports = __webpack_public_path__ + "static/media/icons-popular.20013a79.png";